export var NUGGET_THEMES = {
    REAL_PEOPLE_REAL_STORIES: 'Real People, Real Stories',
    LEARN_AND_EXPLORE: 'Learn & Explore',
    GROW_BY_DOING: 'Grow by Doing',
};
export var NUGGET_VARIANTS = {
    ARTICLE: 'article',
    VIDEO_EXTERNAL: 'video-external',
    VIDEO_INTERNAL: 'video-internal',
    TEXT_RESPONSE: 'text-response',
    POST: 'post',
    AUDIO: 'audio',
    DOCUMENT: 'document',
    PROFILE_EXTERNAL: 'profile-external',
    PROFILE_INTERNAL: 'profile-internal',
    INSTITUTION: 'institution',
    OPPORTUNITY: 'opportunity',
    EVENT: 'event',
    BOOK: 'book',
    COMPETENCY: 'competency',
    SCHOLARSHIPS: 'scholarships',
    CAREER_PATH: 'career-path',
    INTERNSHIP: 'internship',
    RESOURCE: 'resource',
};
export var NUGGET_TYPES = {
    BACKRS_PROFILE_PROFESSIONAL: 'backrs-profile-professional',
    BACKRS_PROFILE_STUDENT: 'backrs-profile-student',
    BACKRS_PROFILE_SERVICE_PROVIDER: 'backrs-profile-service-provider',
    EXTERNAL_PROFILE_PROFESSIONAL: 'external-profile-professional',
    EXTERNAL_PROFILE_STUDENT: 'external-profile-student',
    EXTERNAL_PROFILE_SERVICE_PROVIDER: 'external-profile-service-provider',
    INSTITUTION_HIGH_SCHOOL: 'institution-high-school',
    INSTITUTION_UNIVERSITY: 'institution-university',
    INSTITUTION_EMPLOYER: 'institution-employer',
    INSTITUTION_NONPROFIT: 'institution-nonprofit',
    INSTITUTION_OTHER: 'institution-other',
    NETWORK: 'network',
    CONTENT: 'content',
    ACTIVITY: 'activity',
    OPPORTUNITY: 'opportunity',
};
export var NUGGET_FORMATS = {
    VIDEO: 'video',
    EVENT: 'event',
    AUDIO_FILE: 'audio-file',
    RESUMES_CV: 'resumes-cv',
    TRANSCRIPT: 'transcript',
    DOCUMENT: 'document',
    BOOK: 'book',
    PRODUCT: 'product',
    SERVICE: 'service',
    APP: 'app',
    COURSE: 'course',
    PROFILE: 'profile',
    POST: 'post',
    ARTICLE: 'article',
    PODCAST: 'podcast',
    URL_DESCRIPTION: 'url-description',
    SHADOWING: 'shadowing',
    INTERNSHIP: 'internship',
    FULL_TIME_POSITION: 'full-time-position',
    RESEARCH: 'research',
    VOLUNTEERING: 'volunteering',
    ENRICHMENT: 'enrichment',
    SCHOLARSHIPS: 'scholarships',
};
export var NUGGET_VALIDATION_TYPES = {
    BACKRS: 'Backrs',
    USER: 'User',
    EXPERT: 'Expert',
    SPONSOR: 'Sponsor',
};
export var ASK_LUBAV_BUTTON_ENDPOINTS = {
    CAREER_TRACK_THREE_ROLES_FOR_ME: 'career-track/three-roles-for-me',
    CAREER_TRACK_ROLES_BY_TRACK: 'career-track/roles-by-track',
    CAREER_TRACK_COMPENSATION: 'career-track/compensation',
    CAREER_TRACK_REQUIREMENTS_TO_SUCCEED: 'career-track/requirements-to-succeed',
    CAREER_TRACK_AM_I_ON_TRACK: 'career-track/am-i-on-track',
    CAREER_TRACK_AI_DISRUPTION: 'career-track/ai-disruption',
    INTERNSHIP_AM_I_A_GOOD_FIT: 'internship/am-i-a-good-fit',
    INTERNSHIP_SIMILAR_ROLES: 'internship/similar-roles',
    INTERNSHIP_INCREASE_MY_ODDS: 'internship/increase-my-odds',
    CAREER_PATH_FIT_EXPLAINER: 'career-track/explain-career-path-fit',
    COLLEGE_AM_I_A_GOOD_FIT: 'college/am-i-a-good-fit',
    COLLEGE_EXAMPLE_PROFILES: 'college/example-extracurricular-profiles',
    COLLEGE_WHAT_DO_STUDENTS_SAY: 'college/what-do-students-say',
    COLLEGE_CAMPUS_LIFE: 'college/campus-life',
    COLLEGE_HOW_CAN_I_LEARN_MORE: 'college/how-can-i-learn-more',
    COLLEGE_IMPROVE_MY_ODDS: 'college/improve-my-odds',
};
